/* eslint-disable */
import React, { useState } from "react";
import Select from "react-select";
import "./HireToRetire.css";
import styles from "./HireToRetire.module.css";
import DomainTile from "../../components/DomainTile/DomainTile";
import BarLineChart from "../../atomicComponents/BarLineChart/BarLineChart";
import DashboardSection from "../../components/DashboardContainer/DashboardSection";

function TimeOfficeRetrialsComp() {
  const entityOptions = [
    { value: "undefined", label: "Select" },
    { value: "All", label: "-All-" },
    { value: "tmcv", label: "TMCV" },
    { value: "tmpv", label: "TMPV" },
    { value: "jlr", label: "JLR" },
    { value: "agratas", label: "Agratas" },
  ];

  //   const geographyOptions = [
  //     { value: 'undefined', label: 'Select' },
  //     { value: 'All', label: '-All-' },
  //     { value: 'domastic', label: 'Domastic' },
  //     { value: 'international', label: 'International' },
  //   ];

  const yearOptions = [
    { value: "undefined", label: "Select" },
    { value: "All", label: "-All-" },
    { value: "2025", label: "2025" },
    { value: "2024", label: "2024" },
  ];

  const quarterOptions = [
    { value: "undefined", label: "Select" },
    { value: "All", label: "-All-" },
    { value: "Q1", label: "Q1" },
    { value: "Q2", label: "Q2" },
    { value: "Q3", label: "Q3" },
    { value: "Q4", label: "Q4" },
  ];

  const monthOptions = [
    { value: "undefined", label: "Select" },
    { value: "All", label: "-All-" },
    { value: "Jan", label: "Jan" },
    { value: "Feb", label: "Feb" },
    { value: "Mar", label: "Mar" },
    { value: "Apr", label: "Apr" },
    { value: "May", label: "May" },
    { value: "Jun", label: "Jun" },
    { value: "Jul", label: "Jul" },
    { value: "Aug", label: "Aug" },
    { value: "Sep", label: "Sep" },
    { value: "Oct", label: "Oct" },
    { value: "Nov", label: "Nov" },
    { value: "Dec", label: "Dec" },
  ];

  const [entity, setEntity] = useState(yearOptions[0]);
  const [geography, setgeography] = useState(yearOptions[0]);
  const [year, setYear] = useState(yearOptions[0]);
  const [quarter, setQuarter] = useState(quarterOptions[0]);
  const [month, setMonth] = useState(monthOptions[0]);

  const handleApply = () => {
    console.log("Apply clicked with:", {
      year: year.value,
      quarter: quarter.value,
      month: month.value,
    });
  };

  const handleReset = () => {
    setEntity(entity[0]);
    setgeography(geography[0]);
    setYear(yearOptions[0]);
    setQuarter(quarterOptions[0]);
    setMonth(monthOptions[0]);
  };

  const stats = [
    { title: "Paid On Time", value: 98.21 },
    { title: "PO Penetration", value: 99.17 },
    { title: "PO Creation Volume", value: 7820 },
    { title: "MSME Vendor Enrolled", value: 523 },
    { title: "Invoice Verified (Automatic)", value: 525897 },
    { title: "Invoice Verified (Manual)", value: 26347 },
  ];

  const chartData = [
    {
      month: "Jan",
      withinSLA: 149,
      outsideSLA: 0,
      accuracy: 100,
      timeliness: 100,
    },
    {
      month: "Feb",
      withinSLA: 120,
      outsideSLA: 1,
      accuracy: 99,
      timeliness: 99,
    },
    {
      month: "Mar",
      withinSLA: 160,
      outsideSLA: 1,
      accuracy: 95,
      timeliness: 99,
    },
    {
      month: "Apr",
      withinSLA: 149,
      outsideSLA: 0,
      accuracy: 100,
      timeliness: 100,
    },
    {
      month: "May",
      withinSLA: 120,
      outsideSLA: 1,
      accuracy: 99,
      timeliness: 99,
    },
    {
      month: "June",
      withinSLA: 160,
      outsideSLA: 1,
      accuracy: 95,
      timeliness: 99,
    },
    {
      month: "July",
      withinSLA: 149,
      outsideSLA: 0,
      accuracy: 100,
      timeliness: 100,
    },
    {
      month: "Aug",
      withinSLA: 120,
      outsideSLA: 1,
      accuracy: 99,
      timeliness: 99,
    },
    {
      month: "Sept",
      withinSLA: 160,
      outsideSLA: 1,
      accuracy: 95,
      timeliness: 99,
    },
    {
      month: "Oct",
      withinSLA: 149,
      outsideSLA: 0,
      accuracy: 100,
      timeliness: 100,
    },
    {
      month: "Nov",
      withinSLA: 120,
      outsideSLA: 1,
      accuracy: 99,
      timeliness: 99,
    },
    {
      month: "Dec",
      withinSLA: 160,
      outsideSLA: 1,
      accuracy: 95,
      timeliness: 99,
    },
  ];

  const datasets = [
    {
      type: "bar",
      label: "Within SLA",
      data: chartData.map((item) => item.withinSLA),
      backgroundColor: "#0072CE",
    },
    {
      type: "bar",
      label: "Outside SLA",
      data: chartData.map((item) => item.outsideSLA),
      backgroundColor: "#87CEEB",
    },
    {
      type: "line",
      label: "Accuracy %",
      data: chartData.map((item) => item.accuracy),
      borderColor: "#90EE90",
      backgroundColor: "#90EE90",
      yAxisID: "y1",
      tension: 0.3,
      fill: false,
      pointRadius: 5,
    },
    {
      type: "line",
      label: "Timeliness",
      data: chartData.map((item) => item.timeliness),
      borderColor: "#FFA500",
      backgroundColor: "#FFA500",
      yAxisID: "y1",
      tension: 0.3,
      fill: false,
      pointRadius: 5,
    },
  ]

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                onChange={setEntity}
                options={entityOptions}
                isSearchable={false}
              />
            </div>
          </div>
          {/* <div className={styles.filter_panel_col}>
        <label className={styles.filter_label}>Geography</label>
        <div className={styles.filter_select_wrapper}>
          <Select
            value={geography}
            onChange={setgeography}
            options={geographyOptions}
            isSearchable={false}
          />
        </div>
      </div> */}
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Year</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                onChange={setYear}
                options={yearOptions}
                isSearchable={false}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={quarter}
                onChange={setQuarter}
                options={quarterOptions}
                isSearchable={false}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                onChange={setMonth}
                options={monthOptions}
                isSearchable={false}
              />
            </div>
          </div>
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <DomainTile title="Time Office Administration, Retrials" showBackButton={true} />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 mb-4">
          <DashboardSection
            title="Retirals"
            disableDetailView={true}
            detailPath="/Procure-To-Pay"
          >
            <BarLineChart datasets={datasets} chartData={chartData} height={250}/>
          </DashboardSection>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 mb-4">
          <DashboardSection
            title="Time Office Administration"
            disableDetailView={true}
            detailPath="/Procure-To-Pay"
          >
            <BarLineChart datasets={datasets} chartData={chartData} height={250}/>
          </DashboardSection>
        </div>
      </div>
      {/* <div className="row">
        <div className="col-lg-12 mb-4">
          <DashboardSection
            title="Salary Vendor Payments"
            disableDetailView={true}
            detailPath="/Procure-To-Pay"
          >
            <BarLineChart datasets={datasets} chartData={chartData} height={250}/>
          </DashboardSection>
        </div>
      </div> */}
    </>
  );
}

export default TimeOfficeRetrialsComp;
